import React, { ReactNode, SetStateAction, useContext, useEffect, useState } from 'react';
import { useRouter } from 'next/router';
import LogoutRequest from 'components/Modals/LogoutModal/api/LogoutRequest';
import showNotification from 'utils/showNotification';
import getUser from 'api/requests/getUser';
import Button from 'components/Button';
import { appAuthContext } from 'context/AuthContext';
import NavItems from '../NavItems';
import MobileUserCabinet from '../MobileUserCabinet';
import styles from './MobileNavigation.module.css';

type MobileNavProps = {
  setShowAskModal: React.Dispatch<React.SetStateAction<boolean>>;
  setShowRegModal: React.Dispatch<React.SetStateAction<boolean>>;
  unanswered: number | null;
  showSearch: boolean;
  setShowSearch: (show: SetStateAction<boolean>) => void;
  showCabinet?: boolean;
  children?: ReactNode;
  showDropdownOpenBtn?: boolean;
  showChat?: boolean;
  showCabinetAvatar?: boolean;
  profileLinkFromCabinet?: boolean;
};
const MobileNavigation = ({
  setShowAskModal,
  setShowRegModal,
  unanswered,
  showSearch,
  setShowSearch,
  showCabinet = true,
  showDropdownOpenBtn = true,
  showChat = false,
  showCabinetAvatar = true,
  profileLinkFromCabinet = false,
  children,
}: MobileNavProps) => {
  const { user, setUser } = useContext(appAuthContext);
  const router = useRouter();
  const [showMobileNav, setShowMobileNav] = useState<boolean>(false);
  const [dropdownOpen, setDropdownOpen] = useState<boolean>(false);
  const [showDeclineSignout, setShowDeclineSignout] = useState<boolean>(false);

  // Шапка перекрывает виджет саппорта
  useEffect(() => {
    const root = document.getElementById('header');
    if (root !== null) {
      if (showMobileNav) {
        root.style.zIndex = '999999';
      } else {
        root.style.zIndex = '300';
      }
    }
  }, [showMobileNav]);

  useEffect(() => {
    setShowMobileNav(false);
    setDropdownOpen(false);
    setShowDeclineSignout(false);
  }, [router, user]);

  const mobileMenuTogler = () => {
    if (showMobileNav) {
      setDropdownOpen(false);
      setShowDeclineSignout(false);
      setShowSearch(false);
    }
    document.body.style.overflow = !showMobileNav ? 'hidden' : '';
    setShowMobileNav(!showMobileNav);
  };

  const mobileNavVisible = showMobileNav ? styles.nav_mobile__visible : '';

  const signoutHandler = async () => {
    if (showDeclineSignout) {
      const res = await LogoutRequest();
      if (res?.data?.userLogOut?.payload?.success === true) {
        const updateUserData = await getUser();
        setUser(updateUserData);
        setShowMobileNav(false);
        setDropdownOpen(false);
        setShowDeclineSignout(false);
        await router.push('/');
      } else {
        showNotification('error', 'Возникла ошибка');
      }
    }
    setShowDeclineSignout(true);
  };

  return (
    <>
      <div className={styles.burger_container}>
        <div
          className={styles.nav__burger}
          onClick={mobileMenuTogler}
          data-qa-marker="burger_nav_mob"
        />
      </div>
      <div className={`${styles.nav_mobile} ${mobileNavVisible}`}>
        <div className={styles.nav_mobile__content}>
          <div
            className={styles.nav_mobile__close}
            onClick={mobileMenuTogler}
            data-qa-marker="close_pers_menu_btn"
          />
          {!children ? (
            <>
              <NavItems
                showSearch={showSearch}
                setShowSearch={setShowSearch}
                type="mobile"
                unanswered={unanswered}
              />
              <Button
                text="Задать вопрос"
                onClick={() => setShowAskModal(true)}
                addStyles={{
                  display: 'block',
                  padding: '23px 35px 21px',
                  margin: '0 auto',
                }}
                qaMarker="new_question_open_modal_mob"
              />
              {!user?.data?.attributes && (
                <Button
                  text="Войти"
                  type="transparent"
                  onClick={() => setShowRegModal(true)}
                  addStyles={{
                    display: 'block',
                    padding: '53px 0 25px',
                    margin: '0 auto',
                  }}
                  qaMarker="login_btn_mob"
                />
              )}
            </>
          ) : (
            children
          )}
          {user?.data?.attributes && showCabinet && (
            <MobileUserCabinet
              dropdownOpen={dropdownOpen}
              setDropdownOpen={setDropdownOpen}
              signoutHandler={signoutHandler}
              mobileMenuTogler={mobileMenuTogler}
              showDeclineSignout={showDeclineSignout}
              setShowDeclineSignout={setShowDeclineSignout}
              showDropdownOpenBtn={showDropdownOpenBtn}
              showChat={showChat}
              showCabinetAvatar={showCabinetAvatar}
              profileLinkFromCabinet={profileLinkFromCabinet}
            />
          )}
        </div>
      </div>
    </>
  );
};

export default MobileNavigation;
